
import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "antd";
import { FormItemTypeEnum } from "../../../../components2/YhFormBox/Types"
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import { useVehicleModel } from "../vehicleModel"
import useMdmModel from "../../../../model/mdmModel"
import { useNavModel } from "../../../../model/navModel";
import { DetailType } from "../../../../types/FmsEnums";
import {IVehicleSearch,IVehicleParams,IVehicleDetail,IVehicleInsert,IVehicleUpdata,IVehicleDisable} from "../vehicleTypes"
import { setTitle, loadDictParam } from "../../../../utils/utils"
const VehicleDetail = () => {
    const [form] = Form.useForm();
    const { mdmCatalog, mdmBranch, mdmSourceApp, mdmOrgan, dict,customer } = useMdmModel();
    const { selectedNavId, addNav, closeNav, getSelectedNavState, replaceNav, findNav } = useNavModel()
    const { addParam,nature,vehicletype,selectedRow,setVehicletype,setNature,setAddParam, setSelectedRow, setSelectedRowKeys, updataAddParam, updataEditParam, insertDetail, updataDetail} = useVehicleModel()
    const [modes, setModes] = useState<any>(getSelectedNavState("state"))
    const { id, pageParams } = modes
    const { mode, id: ids } = pageParams
    useEffect(() => {
        console.log(addParam)
        if (mode == DetailType.add) {
            form.setFieldsValue(addParam)
        } else if (mode == DetailType.edit || mode == DetailType.look) {
            form.setFieldsValue(selectedRow[0])
        }
    }, [addParam, selectedRow[0]])
    const onFinish = (values: IVehicleInsert | IVehicleUpdata) => {
        if (mode == DetailType.add) {
            insertDetail(values as IVehicleInsert).then(res => {
                if (res) close();
            })
        } else if (mode == DetailType.edit) {
            updataDetail(values as IVehicleDetail).then(res => {
                if (res) close();
            })
        }
    }
    // useEffect(() => {
    //     return () => {
    //         const findInsert = findNav("2-7-1")
    //         const findEdit = findNav("2-7-2")
    //         !!!findInsert && setAddParam({});
    //         !!!findEdit && setSelectedRowKeys([]) && setSelectedRow([]);
    //     }
    // }, [selectedNavId])
    useEffect(()=>{
        setNature(loadDictParam('nature',dict))
        setVehicletype(loadDictParam('vehicle-type',dict))
    },[])
    const close = () => {
        replaceNav(selectedNavId, "2-7")
    }
    const items = [
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "分支编码",
            labelCol: { span: 6 },
            fieldName: "branch",
            options: mdmBranch
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "数据版本号",
            labelCol: { span: 6 },
            fieldName: "ver",
            disable: true,
        },
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "客户名称",
            labelCol: { span: 6 },
            fieldName: "customerCode",
            options: customer
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "车辆编码",
            labelCol: { span: 6 },
            fieldName: "code",
            disable:mode == DetailType.edit,
            // rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "车辆牌照",
            labelCol: { span: 6 },
            fieldName: "licensePlate",
            // disable:mode == DetailType.edit
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "车辆品牌",
            labelCol: { span: 6 },
            fieldName: "brandName",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "车型",
            labelCol: { span: 6 },
            fieldName: "model",
        },
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "车辆类型",
            labelCol: { span: 6 },
            fieldName: "categoryCode",
            options:vehicletype
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "使用性质",
            labelCol: { span: 6 },
            fieldName: "natureCode",
            // options:nature
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "Vin码",
            labelCol: { span: 6 },
            fieldName: "vin",
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "车系",
            labelCol: { span: 6 },
            fieldName: "series",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "发动机号",
            labelCol: { span: 6 },
            fieldName: "engineCode",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "变数箱号",
            labelCol: { span: 6 },
            fieldName: "gearboxCode",
        },
        {
            type: FormItemTypeEnum.Datepicker,
            span: 6,
            fieldLabel: "生产日期",
            labelCol: { span: 6 },
            fieldName: "productionTime",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "车桥",
            labelCol: { span: 6 },
            fieldName: "axle",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "车身颜色",
            labelCol: { span: 6 },
            fieldName: "color",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "底盘号",
            labelCol: { span: 6 },
            fieldName: "chassisCode",
        },
        {
            type: FormItemTypeEnum.Datepicker,
            span: 6,
            fieldLabel: "注册日期",
            labelCol: { span: 6 },
            fieldName: "registerDate",
        },
        {
            type: FormItemTypeEnum.Datepicker,
            span: 6,
            fieldLabel: "出厂日期",
            labelCol: { span: 6 },
            fieldName: "deliveryTime",
        },
        {
            type: FormItemTypeEnum.Datepicker,
            span: 6,
            fieldLabel: "登记日期",
            labelCol: { span: 6 },
            disable:true,
            fieldName: "createTime",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 12,
            fieldLabel: "备注",
            labelCol: { span: 3 },
            fieldName: "note",
        },
        {
            type: FormItemTypeEnum.Switch,
            span: 6,
            fieldLabel: "状态",
            labelCol: { span: 6 },
            fieldName: "enable",
            valuePropName: "checked",
            checkedChildren: "启用",
            unCheckedChildren: "禁用"
        },
    ]
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}车辆信息</div>
    const reset = () => {
        form.resetFields()
        if (mode == DetailType.add) {
            setAddParam({})
        } else if (mode == DetailType.edit) {
            form.setFieldsValue({code:selectedRow[0].code})
            setSelectedRow([{code:selectedRow[0].code}])
        }
    }    
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => form.submit()}
        >保存</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => reset()}
        >重置</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => close()}
        >取消</Button>
    </>
    return <Form
        form={form}
        onValuesChange={mode == DetailType.add ? updataAddParam : updataEditParam}
        onFinish={onFinish}
    >
        <YhFormItemsBox disabled={mode == DetailType.look} items={items} title={title} action={action} IclassName="p-20" />
    </Form>
}
export default VehicleDetail